import { meshLog, SPGet, SPSet } from "./spUtils";
import { IsDevicePir, IsEmergencyDevice } from "./pidUtils";
import { getGroupNormalImgWithName, getGroupSelectImgWithName } from "./fileUtils";
import { startDelayedUploadAction } from "./net/netUtils";
import { exportTimeSpecial } from "./timeUtils";


//---------------------------------------------------------------Building--------------------------------------------------------------
//判断Building名称是否重复
export const judgeBuildingNameExist = (name, owner) => {
    let arr = JSON.parse(SPGet("buildingList"))
    for (let i = 0; i < arr.length; i++) {
        if (name == owner) {
            continue
        }
        if (arr[i].buildingName == name) {
            return true;;
        }
    }
    return false;
}
//获取building列表名称
export const getBuildingArr = () => {
    let arr = [];
    let lists = JSON.parse(SPGet("buildingList"));
    for (let i = 0; i < lists.length; i++) {
        arr[i] = { value: i, 'label': lists[i].buildingName }
    }
    return arr;
}

//获取选中的BuildingUUID
export const getSelectBuildingUUID = (name) => {
    let uuid = "";
    let lists = JSON.parse(SPGet("buildingList"));
    for (let i = 0; i < lists.length; i++) {
        if (lists[i].buildingName == name) {
            uuid = lists[i].buildingUUID;
        }
    }
    meshLog('building', name, uuid);
    return uuid;
}
//获取选中的Building Time
export const getSelectBuildingTime = (name) => {
    let time = "";
    let lists = JSON.parse(SPGet("buildingList"));
    for (let i = 0; i < lists.length; i++) {
        if (lists[i].buildingName == name) {
            time = lists[i].createTime;
        }
    }
    return exportTimeSpecial(time);
}
//获取选中的Building Addr
export const getSelectBuildingAddr = (name) => {
    let info = "";
    let lists = JSON.parse(SPGet("buildingList"));
    for (let i = 0; i < lists.length; i++) {
        if (lists[i].buildingName == name) {
            let mm1=lists[i].companyName;
            let mm2=lists[i].address;
            let mm3=lists[i].city;
            if(mm1.length>10){
                mm1=mm1.substring(0, 10)+"..."
            }
            if(mm2.length>15){
                mm2=mm2.substring(0, 10)+"..."
            }
            if(mm3.length>15){
                mm3=mm3.substring(0, 10)+"..."
            }
            info = mm1 + ", " + mm2 + ", " + mm3;
        }
    }
    return info;
}

//---------------------------------------------------------------Mesh--------------------------------------------------------------
//判断Mesh名称是否重复
export const judgeMeshNameExist = (name, owner) => {
    let arr = JSON.parse(SPGet("meshList"))
    for (let i = 0; i < arr.length; i++) {
        if (name == owner) {
            continue
        }
        if (arr[i].meshName == name) {
            return true;;
        }
    }
    return false;
}
//获取mesh列表
export const getMeshArr = () => {
    let arr = [];
    let lists = JSON.parse(SPGet("meshList"));
    for (let i = 0; i < lists.length; i++) {
        arr[i] = { value: i, 'label': lists[i].meshName }
    }
    return arr;
}
//获取模拟计量mesh列表
export const getEnergyMeshArr = () => {
    let arr = [];
    let lists = JSON.parse(SPGet("energy_meshList"));
    for (let i = 0; i < lists.length; i++) {
        arr[i] = { value: i, 'label': lists[i].meshName }
    }
    return arr;
}
export const getDefaultMeshName = () => {
    let name = "";
    let lists = JSON.parse(SPGet("meshList"));
    for (let i = 0; i < lists.length; i++) {
        if (i == 0) {
            name = lists[i].meshName;
        }
    }
    // meshLog('mesh', name);
    return name;
}


//---------------------------------------------------------------Group--------------------------------------------------------------
//判断Group名称是否重复
export const judgeGroupNameExist = (name) => {
    let arr = JSON.parse(SPGet("groupList"))
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].name == name) {
            return true;;
        }
    }
    return false;
}
///计量获取group名称
export const getIDBygroupName = (name) => {
    let groupID = '';
    const groupList = JSON.parse(SPGet("energy_groupList"))
    for (let i = 0; i < groupList.length; i++) {
        // meshLog('groupList[i].name',);
        if (groupList[i].name == name) {
            groupID = groupList[i].groupID;
        }
    }
    meshLog('groupID', groupID);
    return groupID;
}
//获取group名称
export const getNameBygroupID = (groupID) => {
    let name = '';
    const groupList = JSON.parse(SPGet("groupList"))
    for (let i = 0; i < groupList.length; i++) {
        if (groupList[i].groupID == groupID) {
            name = groupList[i].name;
        }
    }
    return name;
}
//获取模拟计量group列表
export const getEnergyGroupArr = () => {
    let arr = [];
    let lists = JSON.parse(SPGet("energy_groupList"));
    for (let i = 0; i < lists.length; i++) {
        arr[i] = { value: i, 'label': lists[i].name }
    }
    return arr;
}
//获取所有group以及group下的灯--ok
export const getAllGroupsAndDevices = () => {
    let arr = [];
    let arrG = JSON.parse(SPGet("groupList"))
    for (let i = 0; i < arrG.length; i++) {
        let arrInner = [];
        let arrD = JSON.parse(SPGet("nodes"))
        for (let j = 0; j < arrD.length; j++) {
            if (arrD[j].groupID == arrG[i].groupID && IsDevicePir(arrD[j].pid)) {
                arrInner[j] = { 'vid': arrD[j].vid, 'pid': arrD[j].pid, 'name': arrD[j].name, 'macAddress': arrD[j].macAddress, 'isWarning': arrD[j].isWarning }
            }
        }
        let mm = arrInner.length > 0 ? true : false;
        // meshLog('isWarn', arrInner.length,mm);
        arr[i] = { 'id': arrG[i].groupID, 'name': arrG[i].name, 'icon': arrG[i].groupImgName, 'devices': arrInner, checked: false, 'isWarning': mm }
    }
    // meshLog('groups', JSON.parse(SPGet("groupList")));
    meshLog('arr', arr);
    return arr;
}

export const getSelectGroupIconsArr = () => {
    let arr = [
        { "id": 0, "normal": getGroupNormalImgWithName(1), "click": getGroupSelectImgWithName(1), "status": 1 },
        { "id": 1, "normal": getGroupNormalImgWithName(2), "click": getGroupSelectImgWithName(2), "status": 0 },
        { "id": 2, "normal": getGroupNormalImgWithName(3), "click": getGroupSelectImgWithName(3), "status": 0 },
        { "id": 3, "normal": getGroupNormalImgWithName(4), "click": getGroupSelectImgWithName(4), "status": 0 },
        { "id": 4, "normal": getGroupNormalImgWithName(5), "click": getGroupSelectImgWithName(5), "status": 0 },
        { "id": 5, "normal": getGroupNormalImgWithName(6), "click": getGroupSelectImgWithName(6), "status": 0 },
        { "id": 6, "normal": getGroupNormalImgWithName(7), "click": getGroupSelectImgWithName(7), "status": 0 },
        { "id": 7, "normal": getGroupNormalImgWithName(8), "click": getGroupSelectImgWithName(8), "status": 0 },
        { "id": 8, "normal": getGroupNormalImgWithName(9), "click": getGroupSelectImgWithName(9), "status": 0 },
        { "id": 9, "normal": getGroupNormalImgWithName(10), "click": getGroupSelectImgWithName(10), "status": 0 },
        { "id": 10, "normal": getGroupNormalImgWithName(11), "click": getGroupSelectImgWithName(11), "status": 0 },
        { "id": 11, "normal": getGroupNormalImgWithName(12), "click": getGroupSelectImgWithName(12), "status": 0 },
    ]

    return arr;


}
//---------------------------------------------------------------Group 布点图--------------------------------------------------------------
//布点图初始化
export const setDesignGroupArr = () => {
    let arrG = JSON.parse(SPGet("groupList"))
    for (let i = 0; i < arrG.length; i++) {
        if (arrG[i].hasOwnProperty("mapModel")) {
            //存在
            if (!arrG[i].mapModel.hasOwnProperty("color")) {
                arrG[i].mapModel["color"] = 0;
            }
        } else {
            arrG[i]["mapModel"] = { "width": 0, "height": 0, "x": 0, "y": 0, "color": 0 };
        }
    }
    meshLog('groupList??', arrG);
    SPSet('groupList', JSON.stringify(arrG))
}
//布点图删除或新增
export const judgeAddMapGroup = (groupID, width) => {
    let arr = JSON.parse(SPGet("groupList"));
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID) {
            if (width > 0) {
                meshLog('map 删除');
                arr[i].mapModel = { "width": 0, "height": 0, "x": 0, "y": 0, "color": 0 };
            } else {
                meshLog('map 增加');
                arr[i].mapModel = { "width": 200, "height": 200, "x": 100, "y": 100, "color": 0 };
            }
        }
    }
    SPSet('groupList', JSON.stringify(arr))
    startDelayedUploadAction();
    return arr;
}

//布点图排序
export const sortMapGroupArr = (groupID, deviceMac) => {
    let arr = JSON.parse(SPGet("groupList"))
    let arrM = [];
    let num = 0;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID) {
            //最后加
        } else {
            if (arr[i].mapModel.width > 0) { //#33FFF580
                arrM[num] = {
                    "id": arr[i].groupID, "name": arr[i].name, "width": arr[i].mapModel.width, "height": arr[i].mapModel.height,
                    "x": arr[i].mapModel.x, "y": arr[i].mapModel.y, "color": getMapColor(arr[i].mapModel.color) + "80", "devices": sortMapDeviceArr(arr[i].groupID, deviceMac), "isEdit": false
                };
                num++
            }
        }
    }

    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID && arr[i].mapModel.width > 0) {
            //最后加
            arrM[num] = {
                "id": arr[i].groupID, "name": arr[i].name, "width": arr[i].mapModel.width, "height": arr[i].mapModel.height,
                "x": arr[i].mapModel.x, "y": arr[i].mapModel.y, "color": getMapColor(arr[i].mapModel.color), "devices": sortMapDeviceArr(arr[i].groupID, deviceMac), "isEdit": false
            };
            num++;
        }
    }

    meshLog("map list:", groupID, arr);
    return arrM;
}
//更新布点图位置
export const updateMapGroupxy = (groupID, x, y) => {
    let arr = JSON.parse(SPGet("groupList"))
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID) {
            arr[i].mapModel.x = x;
            arr[i].mapModel.y = y;
        }
    }
    SPSet('groupList', JSON.stringify(arr))
    startDelayedUploadAction();
    meshLog("map 位置", groupID, arr);
}
//更新布点图宽高
export const updateMapGroupWidthHeight = (groupID, width, height, x, y) => {
    let arr = JSON.parse(SPGet("groupList"))

    let scaleW = 1;
    let scaleH = 1;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID) {
            //调整比例
            // scaleW=width/arr[i].mapModel.width;
            // scaleH=height/arr[i].mapModel.height;

            arr[i].mapModel.width = width;
            arr[i].mapModel.height = height;
            arr[i].mapModel.x = x;
            arr[i].mapModel.y = y;
        }
    }

    let arrD = JSON.parse(SPGet("nodes"))
    for (let j = 0; j < arrD.length; j++) {
        if (arrD[j].groupID == groupID) {
            if (arrD[j].mapModel.width > 0) {
                let mX = parseInt(arrD[j].mapModel.x * scaleW);
                let mY = parseInt(arrD[j].mapModel.y * scaleH);
                if (mX > width - 20) {
                    mX = width - 25;
                }
                if (mY > height - 20) {
                    mY = height - 25;
                }
                arrD[j].mapModel.x = mX;
                arrD[j].mapModel.y = mY;
            }
        }
    }
    SPSet('groupList', JSON.stringify(arr))
    SPSet('nodes', JSON.stringify(arrD))
    startDelayedUploadAction();
    meshLog("map 大小", groupID, arr);
}
//更新布点图颜色
export const updateMapGroupColor = (groupID, color) => {
    let arr = JSON.parse(SPGet("groupList"))
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID) {
            arr[i].mapModel.color = color;
        }
    }
    SPSet('groupList', JSON.stringify(arr))
    startDelayedUploadAction();
}

//颜色映射表
export const getMapColor = (color) => {
    let str = "";
    if (color == 1) {
        str = "#FFEB33";
    } else if (color == 2) {
        str = "#FF9600";
    } else if (color == 3) {
        str = "#08BF08";
    } else if (color == 4) {
        str = "#33FFF5";
    } else if (color == 5) {
        str = "#7933FF";
    } else if (color == 6) {
        str = "#FF4B33";
    } else if (color == 7) {
        str = "#DC33FF";
    } else if (color == 8) {
        str = "#3364FF";
    } else {
        str = "#33FFF5";
    }
    return str;
}


//---------------------------------------------------------------Device 布点图--------------------------------------------------------------
//布点图初始化
export const setDesignDeviceArr = () => {
    let arr = JSON.parse(SPGet("nodes"))
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].hasOwnProperty("mapModel")) {
            //存在
        } else {
            arr[i]["mapModel"] = { "width": 0, "height": 0, "x": 0, "y": 0 };
        }
    }
    // meshLog('groupList', arrG);
    SPSet('nodes', JSON.stringify(arr))
}
//布点图删除或新增
export const judgeAddMapDevice = (groupID, macAddress, width) => {
    let arr = JSON.parse(SPGet("nodes"));
    let arrD = [];
    let count = 0;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID) {
            if (arr[i].macAddress == macAddress) {
                if (width > 0) {
                    meshLog('map 删除');
                    arr[i].mapModel = { "width": 0, "height": 0, "x": 0, "y": 0 };
                } else {
                    meshLog('map 增加');
                    arr[i].mapModel = { "width": 20, "height": 20, "x": 10, "y": 10 };
                }
            }
            arrD[count] = arr[i];
            count++;
        }
    }
    SPSet('nodes', JSON.stringify(arr))
    startDelayedUploadAction();
    return arrD;
}
//布点图数排序
function sortMapDeviceArr(groupID, deviceMac) {
    let arr = JSON.parse(SPGet("nodes"));
    let arrD = [];
    let count = 0;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID) {
            //选中最后加
            if (arr[i].mapModel.width > 0 && arr[i].macAddress != deviceMac) {
                arrD[count] = { "id": count, "mac": arr[i].macAddress, "pid": arr[i].pid, "x": arr[i].mapModel.x, "y": arr[i].mapModel.y, "color": "#00000000" };
                count++;
            }
        }
    }
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID) {
            //最后加
            if (arr[i].mapModel.width > 0 && arr[i].macAddress == deviceMac) {
                arrD[count] = { "id": count, "mac": arr[i].macAddress, "pid": arr[i].pid, "x": arr[i].mapModel.x, "y": arr[i].mapModel.y, "color": "#ffffff" };
                count++;
            }
        }
    }
    return arrD;
}
//更新布点图位置
export const updateMapDevicexy = (groupID, mac, x, y) => {
    meshLog("map 位置", groupID, mac);
    let arr = JSON.parse(SPGet("nodes"));
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].groupID == groupID && arr[i].macAddress == mac) {
            arr[i].mapModel.width = 20;
            arr[i].mapModel.height = 20;
            arr[i].mapModel.x = x;
            arr[i].mapModel.y = y;
        }
    }
    SPSet('nodes', JSON.stringify(arr))
    startDelayedUploadAction();
    // meshLog("map 位置",groupID,arr);
}

//---------------------------------------------------------------Device--------------------------------------------------------------
//获取到当前groupId下的所有的灯
export const getDevicesByGroupId = (groupId) => {
    meshLog('groupId', groupId);
    const nodes = JSON.parse(SPGet("nodes"))
    meshLog('nodes', nodes);
    let deviceSet = nodes.filter((item) => {
        //if (item.groupID == groupId && item.isProvisioned == true) {
        if (item.groupID == groupId) {
            return item
        }
    })
    return deviceSet
}
//根据mac获取灯的信息--ok
export const getDevicesByMac = (mac) => {
    const nodes = JSON.parse(SPGet("nodes"))
    let deviceSet = nodes.filter((item) => {
        if (item.macAddress == mac) {
            return item
        }
    })
    return deviceSet
}

//根据pid获取版本号--ok
export const getBleVer = (vid) => {
    vid = parseInt(vid);
    // meshLog("wjk vid=", vid);
    if (vid > 0) {
        //     let m1=parseInt(parseInt(vid,16)/2048);
        //     let m2=parseInt(parseInt(parseInt(vid,16)%2048)/64);
        //     let m3=parseInt(parseInt(parseInt(vid,16)%2048)%64);
        let m1 = (vid & 0xF800) >> 11;
        let m2 = (vid & 0x07C0) >> 6;
        let m3 = vid & 0x003F;

        // meshLog("wjk vid:", m1, m2, m3);
        return m1 + '.' + m2 + '.' + m3;
    }
    return '0.0.0';
}
